import NumberToCurrencyPipe from "./NumberToCurrencyPipe";

export type PriceNumberSystem = "indian" | "international";

const preparePriceString = (price: number, numberSystem: PriceNumberSystem = "indian") => {
	/* Absolute Price */

	let NewPriceWoUnit: number | string = Math.abs(price);

	let NewPrice: number | string = "";

	/* ? Shared formatter - divide by factor, trim trailing ".00", append unit */
	const formatWithUnit = (value: number, factor: number, unit: string) => {
		let str = (value / factor).toFixed(2);
		if (str.split(".")[1] === "00") {
			str = str.split(".")[0];
		}
		return str + unit;
	};

	if (numberSystem === "international") {
		/* K (thousand) / M (million) / B (billion) */
		if (NewPriceWoUnit >= 1_000_000_000) {
			NewPrice = formatWithUnit(NewPriceWoUnit, 1_000_000_000, "B");
		} else if (NewPriceWoUnit >= 1_000_000) {
			NewPrice = formatWithUnit(NewPriceWoUnit, 1_000_000, "M");
		} else if (NewPriceWoUnit >= 1_000) {
			NewPrice = formatWithUnit(NewPriceWoUnit, 1_000, "K");
		} else {
			NewPrice = NumberToCurrencyPipe(NewPriceWoUnit);
		}
	} else {
		/* Indian: K (thousand) / L (lakh) / Cr (crore) */
		if (NewPriceWoUnit >= 10000000) {
			NewPrice = formatWithUnit(NewPriceWoUnit, 10000000, "Cr");
		} else if (NewPriceWoUnit >= 100000) {
			NewPrice = formatWithUnit(NewPriceWoUnit, 100000, "L");
		} else if (NewPriceWoUnit >= 1000) {
			NewPrice = formatWithUnit(NewPriceWoUnit, 1000, "K");
		} else {
			NewPrice = NumberToCurrencyPipe(NewPriceWoUnit);
		}
	}

	return NewPrice;
};

export default preparePriceString;
